import { z } from 'zod';
import { api } from '@/shared/services/api';

export const classificationSchema = z.object({
  complexity: z.string().optional(),
  potentialImpact: z.string().optional(),
  tags: z.array(z.string()).min(0).max(10),
});

export type ClassificationFormData = z.infer<typeof classificationSchema>;

export const classifyFeedItem = async (feedItemId: number, data: ClassificationFormData) => {
  const response = await api.post(`/classification/${feedItemId}/classify`, {
    complexity: data.complexity || null,
    potentialImpact: data.potentialImpact || null,
    tags: data.tags || [],
  });

  return response.data;
};
